(() => {
  const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  const money = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.themeVariables?.settings?.moneyFormat || '{{amount}}');
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency', currency: window.Shopify?.currency?.active || 'GBP'
    }).format(cents / 100);
  };

  async function loadRecommendations() {
    const host = document.querySelector('[data-cart-auto-recommendations]');
    const list = host?.querySelector('[data-cart-auto-recommendations-list]');
    const status = host?.querySelector('[data-cart-auto-recommendations-status]');
    if (!host || !list) return;
    host.hidden = true;
    try {
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      if (!cart.items?.length) return;
      // Shopify's recommendations endpoint needs a product context. Query up to
      // three cart products and merge the results, excluding anything already in the cart.
      const inCart = new Set(cart.items.map(item => Number(item.product_id)));
      const contexts = [...new Set(cart.items.slice(0, 3).map(item => item.product_id))];
      const recommendationSets = await Promise.all(contexts.map(async productId => {
        const url = `${root}recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=6&intent=related`;
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) return [];
        const data = await response.json();
        return data.products || [];
      }));
      const seen = new Set();
      const products = recommendationSets.flat().filter(product => {
        const id = Number(product.id);
        if (!product.available || inCart.has(id) || seen.has(id)) return false;
        seen.add(id);
        return true;
      }).slice(0, 4);
      if (!products.length) return;
      list.replaceChildren();
      products.forEach(product => {
        const variant = (product.variants || []).find(item => item.available) || (product.variants || [])[0];
        if (!variant) return;
        const card = document.createElement('article');
        card.className = 'cart-auto-recommendation';
        const image = document.createElement('img');
        image.className = 'cart-auto-recommendation__image';
        image.loading = 'lazy';
        image.alt = product.title || '';
        image.src = product.featured_image || product.images?.[0] || '';
        const details = document.createElement('div');
        details.className = 'cart-auto-recommendation__details';
        const title = document.createElement('a');
        title.className = 'cart-auto-recommendation__title';
        title.href = product.url || `/products/${product.handle}`;
        title.textContent = product.title || '';
        const price = document.createElement('span');
        price.className = 'cart-auto-recommendation__price';
        price.textContent = money(variant.price);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cart-auto-recommendation__add';
        button.textContent = 'Add to cart';
        button.addEventListener('click', async () => {
          button.disabled = true;
          button.textContent = 'Adding…';
          try {
            const addResponse = await fetch(`${root}cart/add.js`, {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
            });
            if (!addResponse.ok) throw new Error('Could not add this product.');
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } catch (error) {
            if (status) status.textContent = error.message || 'Please try again.';
            button.disabled = false;
            button.textContent = 'Add to cart';
          }
        });
        details.append(title, price, button);
        if (image.src) card.append(image);
        card.append(details);
        list.append(card);
      });
      if (list.children.length) host.hidden = false;
    } catch (error) {
      // Fail silently so the normal cart and checkout remain unaffected.
      console.warn('Cart recommendations could not be loaded.', error);
    }
  }

  let scheduled = false;
  function scheduleLoad() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; loadRecommendations(); });
  }
  document.addEventListener('DOMContentLoaded', scheduleLoad);
  document.addEventListener('cart-drawer:refreshed', scheduleLoad);
  document.addEventListener('cart:change', scheduleLoad);
  document.addEventListener('cart:refresh', () => setTimeout(scheduleLoad, 450));
})();
